<!-- 选择器 -->

<template>
  <picker
    v-bind="getPickerBindValue"
  >
    <view :class="[textAlign==='left'?'text-left':'text-right', 'text-gray-1000']">
      <div
        v-if="modelValue?.length"
        :class="{'text-gray-400': disabled}"
      >
        {{ getLabel }}
      </div>
      <div
        v-else
        class="text-gray-500"
      >
        {{ placeholder }}
      </div>
    </view>
  </picker>
</template>
<script lang="ts" setup>
import { computed, reactive, useAttrs, watch } from 'vue'
// import { Picker } from '@nutui/nutui-taro';
import { Picker } from '@tarojs/components'
import { multiSelectorPickerProps } from './props'

/* types 类型注释 */
interface PickerDetail {
  options: Reference.ReferenceItem[][];
}

/* data 数据 */
const attrs = useAttrs()
const emits = defineEmits(['update:modelValue'])
const props = defineProps(multiSelectorPickerProps)
const pickerDetail = reactive<PickerDetail>({
  options: [],
})
const getPickerBindValue = computed(() => ({
  range: pickerDetail.options,
  rangeKey: 'label',
  headerText: props.placeholder,
  mode: 'multiSelector',
  value: props.modelValue?.map((value, itemIndex) => pickerDetail.options[itemIndex].find(option => option.value === value)?.value),
  onChange: e => {
    emits('update:modelValue', e.detail.value.map((valueIndex, itemIndex) => pickerDetail.options[itemIndex][valueIndex].value))
  },
  ...attrs,
}))
const getLabel = computed(() => props.modelValue?.map((value, itemIndex) => pickerDetail.options[itemIndex].find(option => option.value === value)?.label).join('，'))

/* logics 逻辑 */
watch(() => props.options, () => {
  pickerDetail.options = props.options
}, { immediate: true })


/* methods 方法 */
</script>
